import React from 'react';
import { GatsbyImage, GatsbyImageProps, IGatsbyImageData } from 'gatsby-plugin-image';

import { useGetImageByPath } from 'helpers';

interface Props extends Partial<GatsbyImageProps> {
  image?: IGatsbyImageData;
  imagePath?: string;
  className?: string;
  alt: string;
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  objectPosition?: string;
  src?: string;
}

export function Image({
  className = '',
  alt,
  objectFit = 'cover',
  objectPosition = '50% 50%',
  image,
  imagePath = '',
  src = '',
}: Props) {
  const imageByPath = useGetImageByPath([imagePath])[0];

  const imageSrc = image || imageByPath;

  if (imageSrc) {
    return (
      <GatsbyImage
        image={imageSrc}
        objectFit={objectFit}
        objectPosition={objectPosition}
        alt={alt}
        className={className}
      />
    );
  }

  // This method is required for remote resources with incorrect path symbols,
  // which is especially applicable on SVG files
  function replaceSpaceSymbol(source: string) {
    return source?.replace(/%20/g, '%2520');
  }

  return <img src={replaceSpaceSymbol(src)} alt={alt} />;
}
